import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Report } from '../../../../admin/report/report';
import { SubscriptionReportService } from '../../services/subscription-service-report.service';
import { SaveSubscriptionData } from '../../services/save-subscription-data.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../../../shared/services/language.service';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})
export class SubscriptionComponent implements OnInit {
  subscriptionReportData: any[] = [];
  tableColumns: string[] = [
    "subscriptionName",
    "refNum",
    "packageName",
    "createdAt",
    "status",
    "buyerName",
    "buyerEmail",
    "buyerMobile"
  ];
  displayTableColumns = {};

  filterField = [];

  totalNumberOfRecords: number = 0;
  requestBody: Report = {};
  loading: boolean = false;
  reportName: string = '';

  constructor(
    public subscriptionReport: SubscriptionReportService,
    private SaveSubscriptionData: SaveSubscriptionData,
    private route: Router,
    private translate: TranslateService,
    private languageService: LanguageService
  ) { }

  ngOnInit() {
    if (localStorage.getItem("language")) {
      if (localStorage.getItem("language") === "ar") {
        this.loadArContent();
      } else if (localStorage.getItem("language") === "en") {
        this.loadEnContent();
      }
    } else {
      this.loadEnContent();
    }
    this.languageService.languageUpdated.subscribe((lang: string) => {
      if (lang === "ar") {
        this.loadArContent();
      } else if (lang === "en") {
        this.loadEnContent();
      }
    });
    this.subscriptionReport.activateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
  }

  loadArContent() {
    this.translate.use('ar');
    this.reportName = 'تقرير الاشتراك';
    this.displayTableColumns = {
      subscriptionName: 'إسم الإشتراك',
      refNum: 'الرقم المرجعي',
      packageName: 'إسم الباقة',
      createdAt: 'تبدأ فى',
      status: 'الحالة',
      buyerName: 'إسم المشتري',
      buyerEmail: 'البريد الإلكتروني المشتري',
      buyerMobile: 'رقم موبايل المشتري'
    };

    this.filterField = [
      {
        filterFieldName: "Status",
        filterDisplayName: "الحالة",
        defaultValue: "",
        filterOptions: [
          { key: "إظهار الكل", value: null },
          { key: "أوشك على الإنتهاء", value: "Running" },
          { key: "متهى الصلاحية", value: "EXPIRED" },
        ]
      }
    ];
  }

  loadEnContent() {
    this.translate.use('en');
    this.reportName = 'Subscription Report';
    this.displayTableColumns = {
      subscriptionName: 'Subscription Name',
      refNum: 'Transaction Reference Number',
      packageName: 'Package Name',
      createdAt: 'Started at',
      status: 'Status',
      buyerName: 'Buyer Name',
      buyerEmail: 'Buyer Email',
      buyerMobile: 'Buyer Mobile'
    };

    this.filterField = [
      {
        filterFieldName: "Status",
        filterDisplayName: "Status",
        defaultValue: "",
        filterOptions: [
          { key: "Show All", value: null },
          { key: "Running", value: "Running" },
          { key: "EXPIRED", value: "EXPIRED" },
        ]
      }
    ];
  }

  async filter($event: any) {
    if ($event && Object.keys($event).length) {
      this.requestBody.filterOptions = $event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.subscriptionReport.loader().subscribe((val: any) => (this.loading = val));
  }

  async paginate($event: any) {
    this.requestBody.paginationOptions = {
      start: $event.pageIndex * $event.pageSize,
      limit: $event.pageSize
    };
    this.updateTable();
    this.subscriptionReport.loader().subscribe((val: any) => (this.loading = val));
  }

  async searchChange($event: any) {
    if ($event) {
      this.requestBody.searchOptions = {
        searchKey: $event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.subscriptionReport.loader().subscribe((val: any) => (this.loading = val));
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === "") {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.subscriptionReport.loader().subscribe((val: any) => (this.loading = val));
  }

  private formatDate(dateStr: string): string {
    const date = new Date(dateStr);
    const m = date.getMonth() + 1;     // months are 0 indexed

    const month = ("0" + m).slice(-2); // add a 0 padding
    const year = date.getFullYear();
    const day = ("0" + date.getDate()).slice(-2); // add a 0 padding
    return `${year}-${month}-${day}`;
  }

  async updateTable() {
    if (this.requestBody['filterOptions'] && this.requestBody['filterOptions']['createdAt']) {
      // @ts-ignore
      const { startDate, endDate } = this.requestBody['filterOptions']['createdAt'];
      this.requestBody.filterOptions.createdAt.from = this.formatDate(startDate) + " 00:00:00";
      this.requestBody.filterOptions.createdAt.to = this.formatDate(endDate) + " 23:59:59";
    }
    this.subscriptionReport.activateLoader();
    this.subscriptionReport.setParams(this.requestBody);
    const report = await this.subscriptionReport.make();
    report.result.forEach((r: any) => {
      r.createdAt = moment(r.createdAt).format('LL');
      r.endDate = moment(r.endDate).format('LL')
    });
    this.subscriptionReportData = report.result;
    console.log('The Result', this.subscriptionReportData);

    this.totalNumberOfRecords = report.totalNumberOfRows;
  }

  async RefunmForPaymentChange($event: any) {
    let refData = this.subscriptionReportData.filter(ele => ele.refNum == $event.refNum)[0];
    let date: any = {};
    date['startDate'] = this.formatDate(refData.createdAt) + " 00:00:00";
    date['endDate'] = this.formatDate(refData.createdAt) + " 23:59:59";
    this.SaveSubscriptionData.refnum = $event.refNum;
    this.SaveSubscriptionData.date = date;
    this.route.navigate(['/seller/reports/sales']);
  }
}
